import { baseQuery } from '../baseQuery';

type ResendTcResponse = {
  tc_sent: boolean;
  invoice_created: boolean;
};

export const postResendTc = async (id: number) => {
  const response: ResendTcResponse = await baseQuery(`subscriptions/${id}/resend-tc`, {
    type: 'POST',
  });

  return response;
};
